import { makeStyles } from 'tss-react/mui'
import _colors from 'styles/global/_colors'

export const useStyles = makeStyles()((theme) => {
  const responsiveDropdownSizes = {
    [theme.breakpoints.down('md')]: {
      width: '190px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '180px',
      minWidth: '150px',
    },
    '@media (max-width: 375px)': {
      width: '160px',
    },
  }

  const responsiveOptionSizes = {
    [theme.breakpoints.down('md')]: {
      width: 'inherit',
      paddingRight: '14px',
      paddingLeft: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'inherit',
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingRight: '12px',
      paddingLeft: '12px',
      gap: '6px',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingRight: '10px',
      paddingLeft: '10px',
    },
  }

  const responsiveCheckboxSizes = {
    '@media (max-width: 375px)': {
      width: '16px',
      height: '16px',
      marginRight: '6px',
    },
  }

  const responsiveSpanSizes = {
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    '@media (max-width: 375px)': {
      fontSize: '12px',
    },
  }

  return {
    comparisonTabsContainer: {
      width: '420px',
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: '420px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: '100%',
      },
    },
    comparisonTabWrapper: {
      flex: 1,
      position: 'relative',
    },
    comparisonTab: {
      width: '100%',
      height: '40px',
      padding: '4px 16px 4px 16px',
      backgroundColor: _colors.white,
      border: `2px solid ${_colors.blue}`,
      color: _colors.blue,
      fontFamily: 'HP Simplified',
      fontSize: '15px',
      lineHeight: '150%',
      letterSpacing: '0.15px',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        fontSize: '13px',
        padding: '4px 12px',
        height: '38px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        padding: '4px 8px',
        height: '34px',
      },
      '@media (max-width: 375px)': {
        fontSize: '11px',
        padding: '4px 6px',
        height: '32px',
      },
      '&:hover': {
        backgroundColor: _colors.white,
      },
      '&.active': {
        backgroundColor: _colors.blue,
        color: _colors.white,
      },
    },
    comparisonTabFirst: {
      borderRadius: '24px 0 0 24px',
      [theme.breakpoints.down('sm')]: {
        borderRadius: '20px 0 0 20px',
      },
    },
    comparisonTabLast: {
      borderRadius: '0 24px 24px 0',
      borderRight: `2px solid ${_colors.blue}`,
      [theme.breakpoints.down('sm')]: {
        borderRadius: '0 20px 20px 0',
      },
    },
    approvalDropdown: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      width: '300px',
      backgroundColor: _colors.white,
      border: `1px solid ${_colors.lightGray}`,
      borderRadius: '4px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      marginTop: '4px',
      padding: '8px 0',
      zIndex: 1000,
      [theme.breakpoints.down('md')]: {
        width: '200px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '170px',
        padding: '6px 0',
      },
      '@media (max-width: 375px)': {
        padding: '4px 0',
      },
    },
    approvalOption: {
      display: 'flex',
      alignItems: 'center',
      padding: '6px 16px',
      gap: '8px',
      cursor: 'pointer',
      ...responsiveOptionSizes,
      '&:hover': {
        backgroundColor: _colors.lightBlue,
      },
      '& input[type="checkbox"]': {
        appearance: 'none',
        WebkitAppearance: 'none',
        marginRight: '8px',
        width: '16px',
        height: '16px',
        border: `2px solid ${_colors.mediumGray}`,
        borderRadius: '2px',
        backgroundColor: _colors.white,
        cursor: 'pointer',
        flexShrink: 0,
        ...responsiveCheckboxSizes,
        '&:checked': {
          backgroundColor: _colors.blue,
          borderColor: _colors.blue,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            left: '3px',
            top: '0px',
            width: '6px',
            height: '9px',
            border: 'solid white',
            borderWidth: '0 2.5px 2.5px 0',
            transform: 'rotate(45deg)',
          },
        },
      },
      '& span': {
        fontSize: '15px',
        fontWeight: '400',
        lineHeight: '150%',
        letterSpacing: '0.15px',
        ...responsiveSpanSizes,
      },
    },
    guidanceDropdown: {
      position: 'absolute',
      top: '100%',
      left: 'auto',
      right: 0,
      width: '202px',
      height: 'auto',
      backgroundColor: _colors.white,
      border: `1px solid ${_colors.lightGray}`,
      borderRadius: '4px',
      boxShadow:
        '0px 3px 14px 2px #0000001F, 0px 8px 10px 1px #00000024, 0px 5px 5px -3px #00000033',
      marginTop: '4px',
      paddingTop: '8px',
      paddingBottom: '8px',
      zIndex: 1000,
      ...responsiveDropdownSizes,
      [theme.breakpoints.down('md')]: {
        ...responsiveDropdownSizes[theme.breakpoints.down('md')],
        height: 'auto',
      },
      [theme.breakpoints.down('sm')]: {
        ...responsiveDropdownSizes[theme.breakpoints.down('sm')],
        height: 'auto',
        paddingTop: '6px',
        paddingBottom: '6px',
      },
      '@media (max-width: 375px)': {
        ...responsiveDropdownSizes['@media (max-width: 375px)'],
        height: 'auto',
        paddingTop: '4px',
        paddingBottom: '4px',
      },
    },
    guidanceOption: {
      display: 'flex',
      alignItems: 'center',
      width: '202px',
      height: '36px',
      paddingTop: '6px',
      paddingRight: '16px',
      paddingBottom: '6px',
      paddingLeft: '16px',
      gap: '8px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      ...responsiveOptionSizes,
      '&:hover': {
        backgroundColor: _colors.lavender,
      },
      '& input[type="checkbox"]': {
        appearance: 'none',
        WebkitAppearance: 'none',
        marginRight: '8px',
        width: '16px',
        height: '16px',
        border: `2px solid ${_colors.mediumGray}`,
        borderRadius: '2px',
        backgroundColor: _colors.white,
        cursor: 'pointer',
        flexShrink: 0,
        ...responsiveCheckboxSizes,
        '&:checked': {
          backgroundColor: _colors.blue,
          borderColor: _colors.blue,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            left: '3px',
            top: '0px',
            width: '6px',
            height: '9px',
            border: 'solid white',
            borderWidth: '0 2.5px 2.5px 0',
            transform: 'rotate(45deg)',
          },
        },
      },
      '& span': {
        fontSize: '15px',
        fontWeight: '400',
        lineHeight: '150%',
        letterSpacing: '0.15px',
        ...responsiveSpanSizes,
      },
    },
  }
})
